module.exports = __webpack_public_path__ + "assets/img/view-dashboard.e3f0bbfa.svg";